import Resource from '@/api/resources/Resource'
import { orderBy } from 'lodash'
import { TextNormalization } from '@/shared/util/text-normalization'

class TopographicCodesServices extends Resource {
    async getTopographicCodes() {
        const response = await this.axios.get(`/topographicCodes`)
        return orderBy(response.data, element => TextNormalization.removeDiacritics(element.description), ['asc'])
    }

    async search(params) {
        const response = await this.axios.get('/topographicCodes/search', { params })
        return orderBy(response.data, element => TextNormalization.removeDiacritics(element.description), ['asc'])
    }
}

export default new TopographicCodesServices()
